<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Device image to profile image Approval
    </div>
    <div class="card-body">
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row">
                <div class="col-md-4">
                    <label for="Type" class="form-font-label">Type</label>
                    <select class="form-select" aria-label="Type" placeholder="Type" title="Type" name="Type"
                        [(ngModel)]="Filter.SelectType" #CompanyMasterId="ngModel" (change)="ClearData()" required>
                        <option disabled [value]=null>--Select Type--</option>
                        <option value="Pending" class="withcount">
                            <div class="row">
                                <div class="col">Pending - </div>
                                <div class="col-auto">{{Counts.PendingCount}}</div>
                            </div>
                        </option>
                        <option value="Approved">
                            <div class="row">
                                <div class="col">Approved - </div>
                                <div class="col-auto">{{Counts.ApprovedCount}}</div>
                            </div>
                        </option>
                        <option value="PendingWithSenior">
                            <div class="row">
                                <div class="col">Pending With Senior Count - </div>
                                <div class="col-auto">{{Counts.PendingWithSeniorCount}}</div>
                            </div>
                        </option>
                        <option value="Rejected">
                            <div class="row">
                                <div class="col">Rejected - </div>
                                <div class="col-auto">{{Counts.RejectedCount}}</div>
                            </div>
                        </option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label for="Status" class="form-font-label">Employee Type</label>
                    <select class="form-select" aria-label="Status" placeholder="Status" title="Status" name="Status"
                        [(ngModel)]="Filter.EmpType" #Status="ngModel" (change)="ClearData()" required>
                        <option disabled [value]='null'>--Select EmpType--</option>
                        <option value="All">
                            <div class="row">
                                <div class="col">All</div>
                            </div>
                        </option>
                        <option value="front">
                            <div class="row">
                                <div class="col">Front</div>
                            </div>
                        </option>
                        <option value="back">
                            <div class="row">
                                <div class="col">Back</div>
                            </div>
                        </option>
                    </select>
                </div>
                <div class="col-md-2" *ngIf="Filter.SelectType != 'Pending'">
                    <label for="FromDateObj" class="form-font-label"><span class="text-danger">*</span>From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required 
                            (ngModelChange)="ClearData()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-2" *ngIf="Filter.SelectType != 'Pending'">
                    <label for="ToDateObj" class="form-font-label"><span class="text-danger">*</span>To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required 
                            (ngModelChange)="ClearData()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-md-auto align-self-end">
                    <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button>
                </div>
            </div>
        </form>
    </div>
</div>

<div class="card mt-2 border-radius-0 p-1">
    <div class="card-body p-0">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th scope="col"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.SelectType) != 'pending'}">
                        <div style="width:75px"><input class="form-check-input" type="checkbox" id="IsCheckAll"
                                name="IsCheckAll" (click)="ARCheck($event,0,true,true)"> Check All
                            <br />
                            <input class="form-check-input" type="checkbox" id="IsCheckAll" name="IsCheckAll"
                                (click)="ARCheck($event,0,true,false)"> Check
                        </div>
                    </th>
                    <th>{{this.Filter.SelectType == 'Pending'?'Action':'View'}}</th>
                    <th>Employee</th>
                    <th style="width: 200px;">
                        Branch Name</th>
                    <th>Employee Type</th>
                    <th>Profile</th>
                    <th>Aadhar</th>
                    <th>Device</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TableDatas; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    <td class="text-center"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.SelectType) != 'pending'}">
                        <div style="width: 80px;"><input class="form-check-input" type="checkbox" id="IsApprove{{i}}"
                                name="IsApprove{{i}}" (click)="ARCheck($event,i)" [(ngModel)]="TableData['IsARCheck']">
                        </div>
                    </td>
                    <td style="width: 5px;">
                        <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                [routerLink]="['/todo/deviceimage/detail/',TableData['WebESSApprovalRequestTrackingId']]"><i
                                    class="bi bi-info-square me-1"></i>{{this.Filter.SelectType ==
                                'Pending'?'Action':'View'}}</button></div>
                    </td>
                    <td>
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;"
                            [routerLink]="['/todo/deviceimage/detail/',TableData['WebESSApprovalRequestTrackingId']]">
                            <div class="col-2">
                                <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(TableData['EmployeeName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label-dark">{{TableData['EmployeeName']}}</span><br />
                                <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                <span class="text-label-light">{{TableData['DesignationName']}}</span>
                            </div>
                        </div>
                    </td>
                    <td style="width: 200px;">
                        <div style="width: 200px;">{{TableData['BranchName']}}</div>
                    </td>
                    <td>
                        <div style="width: 80px;">{{TableData['EmpType']}}</div>
                    </td>
                    <td class="attachmentThumbTD">
                        <app-thumbnail-attachment
                            *ngIf="TableData['ProfileImage'] != null && TableData['ProfileImage'] != ''"
                            [attachmentUrl]="TableData['ProfileImage']">
                        </app-thumbnail-attachment>
                    </td>
                    <td class="attachmentThumbTD">
                        <app-thumbnail-attachment
                            *ngIf="TableData['AadharImage'] != null && TableData['AadharImage'] != ''"
                            [attachmentUrl]="TableData['AadharImage']">
                        </app-thumbnail-attachment>
                    </td>
                    <td class="attachmentThumbTD">
                        <app-thumbnail-attachment
                            *ngIf="TableData['DeviceImage'] != null && TableData['DeviceImage'] != ''"
                            [attachmentUrl]="TableData['DeviceImage']">
                        </app-thumbnail-attachment>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer"
        *ngIf="this.common.ToLowerCase(this.Filter.SelectType) == 'pending' && TableDatas.length > 0 && this.common.PageRight.IsView">
        <div class="row">
            <div class="col">
                <input type="text" class="form-control" placeholder="Remark" id="Remark" name="LocalCity"
                    [(ngModel)]="Filter.Remark" #Remark="ngModel">
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-danger mx-1" [disabled]="isDisabled"
                    (click)="ApprovalMatrixRequestProcess('Reject')"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reject':'Loading...'}}</button>

                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                    (click)="ApprovalMatrixRequestProcess('Approve')"><i class="bi bi-check2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Approve':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>